/**
 * @generated SignedSource<<c626e0e1d258361b47c6bb212f674c91>>
 * @relayHash 52a601ed9cefc3014953b4911bf24ee6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82e385f940b3de0993301171602367eada1fbeacc34b7e684feafc25fa7bf1ba

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TeamUpdatesFeedAggQuery$variables = {
  containerId: string;
  teamId: string;
};
export type TeamUpdatesFeedAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamUpdatesFeedAgg">;
};
export type TeamUpdatesFeedAggQuery = {
  response: TeamUpdatesFeedAggQuery$data;
  variables: TeamUpdatesFeedAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v3 = {
  "kind": "Variable",
  "name": "teamId",
  "variableName": "teamId"
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v9 = {
  "kind": "ScalarField",
  "name": "canCommentOnUpdates"
},
v10 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v11 = {
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v14 = {
  "kind": "ScalarField",
  "name": "summary"
},
v15 = {
  "kind": "ScalarField",
  "name": "description"
},
v16 = [
  (v7/*: any*/),
  (v14/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "url"
},
v18 = {
  "concreteType": "TownsquareUpdateGenerationSettings",
  "kind": "LinkedField",
  "name": "updateGenerationSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "templateKey"
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v20 = {
  "kind": "ScalarField",
  "name": "ari"
},
v21 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v22 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v23 = {
  "kind": "ScalarField",
  "name": "picture"
},
v24 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v25 = {
  "kind": "ScalarField",
  "name": "start"
},
v26 = {
  "kind": "ScalarField",
  "name": "end"
},
v27 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  {
    "concreteType": "TownsquareTargetDateRange",
    "kind": "LinkedField",
    "name": "dateRange",
    "plural": false,
    "selections": [
      (v25/*: any*/),
      (v26/*: any*/)
    ]
  }
],
v28 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v27/*: any*/)
},
v29 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v30 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v24/*: any*/),
    (v12/*: any*/),
    (v7/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v32 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v33 = [
  (v7/*: any*/)
],
v34 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v7/*: any*/),
          (v12/*: any*/),
          (v24/*: any*/),
          (v23/*: any*/)
        ],
        "type": "AtlassianAccountUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v33/*: any*/),
        "type": "AppUser"
      },
      {
        "kind": "InlineFragment",
        "selections": (v33/*: any*/),
        "type": "CustomerUser"
      }
    ]
  },
  (v7/*: any*/)
],
v35 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v27/*: any*/)
},
v36 = {
  "kind": "ScalarField",
  "name": "newTargetDate"
},
v37 = {
  "kind": "ScalarField",
  "name": "newTargetDateConfidence"
},
v38 = {
  "kind": "ScalarField",
  "name": "archived"
},
v39 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v38/*: any*/)
          ]
        }
      ]
    }
  ]
},
v40 = [
  (v6/*: any*/),
  (v23/*: any*/),
  (v12/*: any*/),
  (v24/*: any*/),
  (v7/*: any*/)
],
v41 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v42 = {
  "concreteType": "TownsquareHighlightConnection",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareHighlightEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v15/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isTownsquareHighlight"
            },
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v40/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "lastEditedBy",
              "plural": false,
              "selections": (v40/*: any*/)
            },
            (v31/*: any*/),
            {
              "kind": "ScalarField",
              "name": "lastEditedDate"
            }
          ]
        }
      ]
    },
    (v41/*: any*/)
  ]
},
v43 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v12/*: any*/),
                (v7/*: any*/),
                (v24/*: any*/),
                (v23/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v32/*: any*/),
            (v31/*: any*/)
          ]
        }
      ]
    },
    (v41/*: any*/)
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "type"
},
v45 = {
  "kind": "ScalarField",
  "name": "subType"
},
v46 = {
  "kind": "ScalarField",
  "name": "source"
},
v47 = {
  "kind": "ScalarField",
  "name": "time"
},
v48 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v47/*: any*/),
    (v7/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "value"
},
v50 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v51 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v52 = [
  (v49/*: any*/)
],
v53 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v54 = {
  "kind": "ScalarField",
  "name": "score"
},
v55 = [
  (v49/*: any*/),
  (v54/*: any*/)
],
v56 = [
  (v49/*: any*/),
  (v54/*: any*/),
  {
    "concreteType": "TownsquareCompletionGoalState",
    "kind": "LinkedField",
    "name": "atCompletionState",
    "plural": false,
    "selections": (v55/*: any*/)
  }
],
v57 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamUpdatesFeedAggQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TeamUpdatesFeedAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamUpdatesFeedAggQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "TownsquareUpdateConnection",
        "kind": "LinkedField",
        "name": "statusUpdates_byTeam",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "watching"
                          },
                          (v8/*: any*/),
                          {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchProject"
                              },
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPrivate"
                          },
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "light"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dark"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "transparent"
                                  }
                                ]
                              }
                            ]
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "startDate"
                          },
                          {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          },
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v14/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v12/*: any*/),
                          (v23/*: any*/),
                          (v7/*: any*/),
                          (v24/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v17/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v34/*: any*/)
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v29/*: any*/)
                      },
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v39/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/)
                    ],
                    "type": "TownsquareProjectUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "isWatching"
                          },
                          (v8/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              },
                              (v9/*: any*/),
                              (v19/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canDeleteUpdates"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v33/*: any*/)
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v44/*: any*/),
                                          (v45/*: any*/),
                                          (v38/*: any*/),
                                          (v46/*: any*/),
                                          (v48/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "externalEntityId"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v25/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v49/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v7/*: any*/),
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "snapshotValue",
                                        "plural": false,
                                        "selections": [
                                          (v49/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "scoringMode"
                          },
                          {
                            "args": [
                              (v4/*: any*/)
                            ],
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v16/*: any*/)
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          (v18/*: any*/),
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v50/*: any*/),
                              (v44/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v51/*: any*/)
                          },
                          {
                            "alias": "successMeasureCount",
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": (v51/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "name",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v52/*: any*/),
                                        "type": "TownsquareGoalTypeCustomName"
                                      },
                                      (v53/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "namePlural",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v52/*: any*/),
                                        "type": "TownsquareGoalTypeCustomNamePlural"
                                      },
                                      (v53/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              },
                              (v7/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareTargetDateRange",
                                "kind": "LinkedField",
                                "name": "dateRange",
                                "plural": false,
                                "selections": [
                                  (v26/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                          },
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                          }
                        ]
                      },
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasConnectedUpdates"
                      },
                      (v14/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v56/*: any*/)
                      },
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v39/*: any*/),
                      (v42/*: any*/),
                      (v31/*: any*/),
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v12/*: any*/),
                                      (v44/*: any*/),
                                      (v45/*: any*/),
                                      (v38/*: any*/),
                                      (v46/*: any*/),
                                      (v48/*: any*/),
                                      {
                                        "args": [
                                          (v57/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  (v49/*: any*/),
                                                  (v47/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      (v12/*: any*/),
                                                      (v23/*: any*/),
                                                      (v7/*: any*/)
                                                    ]
                                                  },
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "origin",
                                                    "plural": false,
                                                    "selections": [
                                                      (v6/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareGoalUpdate",
                                                            "kind": "LinkedField",
                                                            "name": "goalUpdate",
                                                            "plural": false,
                                                            "selections": [
                                                              (v31/*: any*/),
                                                              {
                                                                "concreteType": "TownsquareGoal",
                                                                "kind": "LinkedField",
                                                                "name": "goal",
                                                                "plural": false,
                                                                "selections": (v33/*: any*/)
                                                              },
                                                              {
                                                                "concreteType": "TownsquareGoalState",
                                                                "kind": "LinkedField",
                                                                "name": "newState",
                                                                "plural": false,
                                                                "selections": (v55/*: any*/)
                                                              },
                                                              (v7/*: any*/)
                                                            ]
                                                          }
                                                        ],
                                                        "type": "TownsquareFromGoalUpdate"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          (v31/*: any*/)
                                                        ],
                                                        "type": "TownsquareFromMetricCreation"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "updateDate"
                                                          }
                                                        ],
                                                        "type": "TownsquareFromMetricUpdate"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/),
                                      (v47/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      (v7/*: any*/),
                                      (v49/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v24/*: any*/),
                          (v12/*: any*/),
                          (v23/*: any*/),
                          (v7/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          (v50/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 50
                          }
                        ],
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v50/*: any*/)
                                    ]
                                  },
                                  (v7/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      (v30/*: any*/),
                      (v32/*: any*/),
                      (v17/*: any*/),
                      {
                        "args": [
                          (v57/*: any*/)
                        ],
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": (v34/*: any*/)
                          }
                        ],
                        "storageKey": "viewers(first:100)"
                      },
                      (v43/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v56/*: any*/)
                      },
                      (v35/*: any*/)
                    ],
                    "type": "TownsquareGoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v33/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "filters": [
          "teamId",
          "containerId"
        ],
        "handle": "connection",
        "key": "TeamUpdatesFeedAgg_statusUpdates_byTeam",
        "kind": "LinkedHandle",
        "name": "statusUpdates_byTeam"
      }
    ]
  },
  "params": {
    "id": "82e385f940b3de0993301171602367eada1fbeacc34b7e684feafc25fa7bf1ba",
    "metadata": {},
    "name": "TeamUpdatesFeedAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5463aa36b17680362d5222347224f665";

export default node;
